import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";
import SectionTitle from "@/components/feature/SectionTitle";
import { countByCategory } from "@/utils/articles";

export default function CategorySection() {
  return (
    <section className="bg-background-50" aria-labelledby="category-title">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionTitle
          eyebrow="六大栏目"
          title={<span id="category-title">按主题找你想看的那一类</span>}
          description="每个栏目都有独立的编辑取向，不做无差别搬运。选一个方向，从最近更新开始看。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/materials?cat=${cat.slug}`}
              className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <span className="absolute right-4 top-4 font-heading text-4xl font-black text-background-200 transition-colors group-hover:text-primary-100">
                0{index + 1}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.description}</p>
              <span className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                <span className="text-xs text-foreground-500">
                  {countByCategory(cat.id)} 条话题 · {cat.accentTag}
                </span>
                <span className="flex items-center gap-1 text-xs font-medium text-primary-600">
                  进入栏目
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}